
import { BrowserRouter, Route, Routes } from "react-router-dom"
import Home from "./Components/Home/Home";
import CityCab from "./Components/AdventureCabSection/CityCab";
import EconomyCab from "./Components/AdventureCabSection/EconomyCab";
import LuxuryCab from "./Components/AdventureCabSection/LuxuryCab";
import AdventureCabViewMore from "./Components/AdventureCabSection/AdventureCabViewMore";
import ScooterRide from "./Components/RentBike/SooterRide";
import MotorCycle from "./Components/RentBike/MotorCycle";
import Bicycle from "./Components/RentBike/Bicycle";
import RentCarViewMore from "./Components/CarRentalSection/RentCarViewMore";
import CarRentalData from "./Components/OfferPage/CarRentalData";
import BikeRentalData from "./Components/OfferPage/BikeRentalData";
import CabServicesData from "./Components/OfferPage/CabServicesData";
import CarBooking from "./Components/HeroDataSection/CarBooking";
import BookingDetailPage from "./Components/HeroDataSection/BookingDetailPage";
import TravellerDetailPage from "./Components/HeroDataSection/TravellerDetailPage";
import PaymentPage from "./Components/HeroDataSection/PaymentPage";
import SuccessPage from "./Components/HeroDataSection/SuccessPage";
import FailedPage from "./Components/HeroDataSection/FailedPage";

import RentalDetailPage from "./Components/HeroDataSection/RentalDetailPageWithDriver";
import WithDriverRental from "./Components/HeroDataSection/WithDriverRental";
import SelfDriveRental from "./Components/HeroDataSection/SelfDriveRental";
import VintageRental from "./Components/HeroDataSection/VintageRental";
import RentalDetailPageWithDriver from "./Components/HeroDataSection/RentalDetailPageWithDriver";
import RentalDetailPageSelfDrive from "./Components/HeroDataSection/RentalDetailPageSelfDrive";
import RentalDetailPageVintage from "./Components/HeroDataSection/RentalDetailPageVintage";
import BikeRentalPage from "./Components/HeroDataSection/BikeRentalPage";
import BikeRentalDetailPage from "./Components/HeroDataSection/BikeRentalDetailPage";
import BicycleRentalPage from "./Components/HeroDataSection/BicycleRentalPage";
import BicycleRentalDetailPage from "./Components/HeroDataSection/BicycleRentalDetailPage";
import AdventureTravellerDetailPage from "./Components/AdventureCabSection/AdventureTravellerDetailPage";
import BikeTravellerRentalDetailPage from "./Components/RentBike/BikeTravellerRentalDetailPage";
import BicycleRentalDetailPageData from "./Components/RentBike/BicycleRentalDetailPageData";
import TypeCarRentalPage from "./Components/CarRentalSection/TypeCarRentalPage";
import TypeSelfDriveDetailPage from "./Components/CarRentalSection/TypeSelfDriveDetailPage";
import TypeWithDriverDetailPage from "./Components/CarRentalSection/TypeWithDriverDetailPage";
function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/citycab" element={<CityCab />} />
          <Route path="/economycab" element={<EconomyCab />} />
          <Route path="/luxury-cab" element={<LuxuryCab />} />
          <Route
            path="/adventure-cab-view-more"
            element={<AdventureCabViewMore />}
          />
          <Route path="/scooter-ride" element={<ScooterRide />} />
          <Route path="/motor-cycle" element={<MotorCycle />} />
          <Route path="/bicycle" element={<Bicycle />} />
          <Route path="rent-car-view-more" element={<RentCarViewMore />} />
          <Route path="/offer-car-rental-data" element={<CarRentalData />} />
          <Route path="/offer-bike-rental-data" element={<BikeRentalData />} />
          <Route path="/offer-cab-service-data" element={<CabServicesData />} />
          <Route path="/car-booking" element={<CarBooking />} />
          <Route path="/booking-detail-page" element={<BookingDetailPage />} />
          <Route
            path="/traveller-detail-page"
            element={<TravellerDetailPage />}
          />
          <Route path="/payment-page" element={<PaymentPage />} />
          <Route path="/success-page" element={<SuccessPage />} />
          <Route path="/failed-page" element={<FailedPage />} />
          <Route path="/with-driver-rental" element={<WithDriverRental />} />
          <Route
            path="/rental-detail-page-with-driver"
            element={<RentalDetailPageWithDriver />}
          />
          <Route
            path="/rental-detail-page-self-drive"
            element={<RentalDetailPageSelfDrive />}
          />
          <Route
            path="/rental-detail-page-vintage"
            element={<RentalDetailPageVintage />}
          />
          <Route path="/self-drive-rental" element={<SelfDriveRental />} />
          <Route path="/vintage-rental" element={<VintageRental />} />
          <Route path="/bike-rental-page" element={<BikeRentalPage />} />
          <Route path="/bike-rental-detail-page" element={<BikeRentalDetailPage />} />
          <Route path="/bicycle-rental-page" element={<BicycleRentalPage />} />
          <Route path="/bicycle-rental-detail-page" element={<BicycleRentalDetailPage />} />
          <Route path="/adventure-traveller-detail-page" element={<AdventureTravellerDetailPage />} />
          <Route path="/bike-traveller-rental-detail-page" element={<BikeTravellerRentalDetailPage />} />
          <Route path="/bicycle-rental-detail-page-data" element={<BicycleRentalDetailPageData />} />
          <Route path="/type-car-rental-page" element={<TypeCarRentalPage />} />
          <Route path="/type-self-drive-detail-page" element={<TypeSelfDriveDetailPage />} />
          <Route path="/type-with-driver-detail-page" element={<TypeWithDriverDetailPage/>}/>
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
